export default "__VITE_ASSET__d4fe56db__"